import React from "react";
import { STRINGS } from "../../../strings";
import {
  TrainingCenterBundleItem,
  TrainingCenterCaregiverBundle,
} from "../../../system/AppState/AppStateTrainingCenter";
import { translate } from "../../../translate";
import { LOCK_SVG } from "../../../utils/svgs";
import { TRAINING_ICON } from "../../../utils/svgs_new";
import { AppCard, AppCardContent } from "../../Generic/AppCard";
import { AppIcon } from "../../Generic/AppIcon";
import AsyncImage from "../../Generic/AsyncImage";
import Flex from "../../Generic/Flex";
import { If } from "../../Generic/If";
import { IsDefined } from "../../Generic/IsDefined";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import {
  getDisplayData,
  getTrainingCenterBundleItemStatus,
  isBundleItemUnlocked,
  lookupBundleItemThumbnailUrl,
} from "../../TrainingCenter/TrainingCenterUtils";
import TrainingCenterBundleItemCardStatus from "./TrainingCenterBundleItemCardStatus";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  bundleItem: TrainingCenterBundleItem;
  languagePreference: TrainingCenterLanguagePreference;
  onClick: (bundleItem: TrainingCenterBundleItem) => void;
}

const TrainingCenterBundleItemCard = (props: Props) => {
  const isUnlocked = isBundleItemUnlocked(props.bundle, props.bundleItem.bundleItemId);
  const displayData = getDisplayData(props.bundleItem.displayData, props.languagePreference);
  const status = getTrainingCenterBundleItemStatus(isUnlocked, props.bundleItem);
  const thumbnailUrl = lookupBundleItemThumbnailUrl(props.languagePreference, props.bundleItem);

  const handleClick = () => props.onClick(props.bundleItem);

  return (
    <AppCard className="TrainingCenterBundleItemCard" data-is-locked={!isUnlocked}>
      <If condition={!isUnlocked} comment="!isUnlocked">
        <div className="bundle-item-locked">
          <AppIcon icon={LOCK_SVG} fill="white" style={{ width: 24, height: 30 }} />
          <strong>{translate(STRINGS.LOCKED)}</strong>
        </div>
      </If>

      <AppCardContent onClick={handleClick}>
        <Flex xGap={16} alignItems="center">
          <div className="thumbnail-container">
            <AppIcon icon={TRAINING_ICON} size={32} fill="gray-200" />
            <IsDefined value={thumbnailUrl}>
              {($thumbnailUrl) => <AsyncImage src={$thumbnailUrl} className="thumbnail" />}
            </IsDefined>
          </div>

          <div className="content-container">
            <TrainingCenterBundleItemCardStatus status={status} />
            <span className="bundle-name">{displayData.data.title}</span>
          </div>
        </Flex>
      </AppCardContent>
    </AppCard>
  );
};

export default TrainingCenterBundleItemCard;
